<template>
  <div class="auth">
    <transition name="auth-router" mode="out-in">
      <router-view class="router" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "auth",
};
</script>

<style lang="scss" scoped>
.auth {
  min-height: 120vh;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: contain;
  background: -webkit-gradient(linear,
    left top,
    right bottom,
    color-stop(0%, #009ed4),
    color-stop(100%, #5029c3));
}
</style>
